import internshipGuideData from './internship-guide-content.json';
import type { InternshipGuideContent } from './types';

export * from './types';

export const internshipGuideContent = internshipGuideData as InternshipGuideContent;
